module.exports = __webpack_public_path__ + "static/3A841E_1_0-f0b11172d143d41b66c46293b89ff46f.woff";